import {
  UPDATE_CAMPAIGN_STATUS,
  UPDATE_CAMPAIGN_STATUS_FAILURE,
  UPDATE_CAMPAIGN_STATUS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateCampaignStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CAMPAIGN_STATUS:
      return { ...state, loading: true };
    case UPDATE_CAMPAIGN_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_CAMPAIGN_STATUS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateCampaignStatusReducer;
